import React from 'react';

var LobbySection = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: 'pgc-lobby-section' }, children);
};

export { LobbySection };
